const testimonials = [
  {
    id: 1,
    name: "Rohit Sharma",
    role: "Business Owner",
    rating: 5,
    message:
      "After using Vastukkalp products, I noticed a positive shift in my office environment. My business growth has improved significantly.",
  },
  {
    id: 2,
    name: "Priya Mehta",
    role: "Homemaker",
    rating: 5,
    message:
      "The energy in my home feels so calm and peaceful now. These Vastu products truly bring harmony and positivity.",
  },
  {
    id: 3,
    name: "Amit Patel",
    role: "Entrepreneur",
    rating: 4,
    message:
      "I was skeptical at first, but after placing the Vastu items correctly, I experienced better focus and success in my work.",
  },
  {
    id: 4,
    name: "Neha Shah",
    role: "Interior Designer",
    rating: 5,
    message:
      "I recommend Vastukkalp products to my clients. They are beautifully designed and aligned with Vastu principles.",
  },
  {
    id: 5,
    name: "Karan Desai",
    role: "IT Professional",
    rating: 4,
    message:
      "Great quality and authentic products. I feel more positive and energetic at home after using them.",
  },
];

export default testimonials;